import { getViewManager } from '@affine/core/blocksuite/manager/view';
import { WorkspaceImpl } from '@affine/core/modules/workspace/impls/workspace';
import { BlockStdScope } from '@blocksuite/affine/std';
import { nanoid } from 'nanoid';
import { Doc as YDoc } from 'yjs';

export interface DetachedChatStd {
  std: BlockStdScope;
  dispose: () => void;
}

/**
 * Rendering-only editor context for chat surfaces without an active document.
 * It must stay detached from workspace docs because reading a real Store starts
 * on-demand sync for that document.
 */
export function createDetachedChatStd(): DetachedChatStd {
  const collection = new WorkspaceImpl({
    rootDoc: new YDoc({ guid: `detached-chat-${nanoid()}` }),
  });
  collection.meta.initialize();

  const doc = collection.createDoc('detached-chat-doc');
  const std = new BlockStdScope({
    store: doc.getStore(),
    extensions: [...getViewManager().config.init().value.get('page')],
  });
  std.render();

  return {
    std,
    dispose: () => collection.dispose(),
  };
}
